import { IconProps } from './types';

interface IconContainerProps extends Pick<
  IconProps,
  'className' | 'style' | 'ariaLabel' | 'onClick' | 'size'
> {
  children: React.ReactNode;
}

/**
 * Контейнер для иконок с базовыми стилями и интерактивностью
 */
export const IconContainer: React.FC<IconContainerProps> = ({
  children,
  className,
  style,
  ariaLabel,
  onClick,
  size = 48,
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        cursor: onClick ? 'pointer' : undefined,
        ...style,
      }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
};
